import PosSale from '@/models/POS/PosSale'
import PosEmployeeSale from '@/models/POS/PosEmployeeSale'
import API from '@/services/API/api'
import { getFetchDataFunction } from './DataTableService'
import Store from '../../store/store'

import {
    arrayToFrontEndFormat,
    objectToFrontEndFormat,
} from '@/services/ObjectFormatter'
import axios from 'axios'

// services
import PosSaleService from '@/services/API/POS/PosSale'

const SALE_CUSTOMER = 'SC'
const SALE_EMPLOYEE = 'SE'

const responseFormat = [
    {
        back: 'id',
        front: 'id',
    },
    {
        back: 'ticket_total',
        front: 'ticketTotal',
    },
    {
        back: 'iva',
        front: 'iva',
    },
    {
        back: 'pos_detail_sales',
        front: 'posDetailSales',
    },
    {
        back: 'pos_sale_type',
        front: 'PosSaleType',
    },
    {
        back: 'sl_customer_id',
        front: 'CustomerId',
    },
]

const fetchSale = async function(id) {
    let sale = await PosSale.include(
        'pos_detail_sales.wh_product',
        'sl_customer',
        'sl_customer_branch_offices.g_commune',
        'g_seller_user.hr_employee'
        // 'g_cashier_user.hr_emploeyee'
    )
        .append('changed_dte')
        .find(id)
    return sale
}

const fetchSaleWithPayment = async function(id) {
    let sale = await PosSale.include(
        'pos_detail_sales.wh_product',
        'sl_customer',
        'sl_sale_ticket',
        'sl_sale_invoice'
    )
        .append('payments')
        .find(id)

    return sale
}

//TODO Waiting new includes from backend
const fetchSaleEmployee = async function(ticketCode) {
    try {
        let sale = await PosEmployeeSale.include(
            'pos_detail_employee_sales.wh_product',
            'g_seller_user.hr_employee',
            'g_employee_user.hr_employee'
        ).find(ticketCode)
        return sale
    } catch (error) {
        return error.response
    }
}

const fetchBanks = async function() {
    try {
        // let banks = await banks.custom('')
        let response = await axios.get(API.GET_BANKS)
        //console.log('response.data', response.data)
        return response.data
    } catch (error) {
        //console.log(error)
        return error.response
    }
}

const sendSale = async function(
    idTicket,
    change,
    posSaleType,
    idCustomer,
    arrayPayments,
    payer, //SC or SE
    roundingLaw,
    applyRoundLaw,
    ocNumber,
    integrationNumber = null,
    officeID,
    invoiceObservation,
    idsMultipleTickets = null,
    cashChange,
    gCoreBusinessSiiId = null,
    switchMultiTicket = false
) {
    try {
        let sale_payment = []
        var i = 0
        // console.log({ arrayPayments })
        for (i = 0; i < arrayPayments.length; i++) {

            // required
            let payment         = arrayPayments[i]
            let paymentMethod   = arrayPayments[i].paymentMethod
            // let saleData        = {}

            let sale_data = {
                id_sale_payment_id: arrayPayments[i].paymentMethod,
                amount_payment: arrayPayments[i].payment,
            }

            // initialize sale data
            switch(paymentMethod) {
                case 8: 
                    sale_data = PosSaleService.mapSaleCreditPayment(payment, change);
                    break;
            }

            if (arrayPayments[i].paymentMethod == 4) {
                //cheque
                let checkDATA = checkFormat(arrayPayments[i].paymentDetail)
                sale_payment.push(Object.assign({}, sale_data, checkDATA))
            } else if (
                arrayPayments[i].paymentMethod == 2 ||
                arrayPayments[i].paymentMethod == 3
            ) {
                // debito/credito (transbank)
                let isTransbankIntegrated =
                    Store.state.SessionModule.isTransbankIntegrated
                let voucherData = {
                    voucher_number: parseInt(
                        arrayPayments[i].paymentDetail.voucher
                    ),
                }
                if (isTransbankIntegrated) {
                    voucherData.shares_number = parseInt(
                        arrayPayments[i].paymentDetail.shares_number
                    )
                    voucherData.terminal_id =
                        arrayPayments[i].paymentDetail.terminal_id
                    voucherData.authorization_code =
                        arrayPayments[i].paymentDetail.authorization_code
                }
                sale_payment.push(Object.assign({}, sale_data, voucherData))
            } else if (arrayPayments[i].paymentMethod == 5) {
                if (payer === 'SE') {
                    // Crédito empleado
                    let payTransfer = {
                        credit_installments:
                            arrayPayments[i].paymentDetail.creditInstallments,
                    }
                    sale_payment.push(Object.assign({}, sale_data, payTransfer))
                } else {
                    // Crédito Factura Cliente
                    let payCustomerCredit = {
                        customer_credit_option_id: await Store.dispatch(
                            'SessionModule/transformPchPaymentConditionIdToCustomerCreditOptionId',
                            arrayPayments[i].paymentDetail.id
                        ),
                    }
                    sale_payment.push(
                        Object.assign({}, sale_data, payCustomerCredit)
                    )
                }
            } else if (arrayPayments[i].paymentMethod == 6) {
                // Bank transfer
                let payRoll = {
                    transfer_number: parseInt(
                        arrayPayments[i].paymentDetail.transNumber
                    ),
                }
                sale_payment.push(Object.assign({}, sale_data, payRoll))
            } else if (arrayPayments[i].paymentMethod == 8) {
                // Sale Credit Note
                let payRoll = {
                    sl_sale_credit_note_id: parseInt(
                        arrayPayments[i].paymentDetail.sl_sale_credit_note_id
                    ),
                }
                sale_payment.push(Object.assign({}, sale_data, payRoll))
            } else {
                let cashPayment =
                    parseInt(arrayPayments[i].payment) - parseInt(change)
                sale_data.amount_payment = cashPayment.toString()

                if (applyRoundLaw) {
                    sale_data.rounding_law = roundingLaw
                } else {
                    sale_data.rounding_law = 0
                }
                sale_payment.push(sale_data)
            }
        }

        let customerData = {
            sale_id: idTicket,
            sale_payment: sale_payment, // array with all payments made by the customer
            pos_sale_type: posSaleType,
            customer_id: idCustomer,
            purchase_order: ocNumber,
            invoice_observation: invoiceObservation,
            sale_ids: idsMultipleTickets,
            g_core_business_sii_id: gCoreBusinessSiiId,
        }

        let employeeData = {
            employee_sale_id: idTicket,
            cashier_user_id: 1,
            sale_payment: sale_payment,
        }
        const SALE_ROUTE =
            payer == 'SX'
                ? process.env.VUE_APP_API_ROUTE + '/pos_sale/pay_change'
                : payer == SALE_EMPLOYEE
                ? API.SALE_EMPLOYEE
                : API.SALE_CUSTOMER
        const saleData = payer === SALE_EMPLOYEE ? employeeData : customerData

        //FIXME: Integration only
        if (posSaleType === 1) saleData.ticket_counter = integrationNumber
        if (posSaleType === 2) saleData.invoice_number = integrationNumber
        // if (ticket_number) saleData.ticket_number = ticket_number
        // if (invoice_number) saleData.invoice_number = invoice_number
        //ENDFIXME
        saleData.sl_customer_branch_offices_id = officeID || null
        saleData.default_branch_office = officeID
        saleData.default_branch_office_id = officeID
        saleData.cash_change = cashChange
        let user = JSON.parse(localStorage.getItem('user'))
        saleData.cashier_user_id = user.id
        // console.log({ saleData })
        // return

        let response = ''
        if (idsMultipleTickets.length > 1 && switchMultiTicket === true) {
            response = await axios.post(API.SALE_CUSTOMER_MULTIPLE, saleData)
        } else {
            saleData.sale_id = idsMultipleTickets[0]
            response = await axios.post(SALE_ROUTE, saleData)
        }

        return response.data
    } catch (error) {
        return error.response
    }
}

const annulSale = async function(payload) {
    try {
        let sale =
            payload.payer === SALE_CUSTOMER
                ? await PosSale.find(payload.ticketCode)
                : await PosEmployeeSale.find(payload.ticketCode)
        let response = await sale.delete()
        return response.data
    } catch (error) {
        return error.response.data
    }
}

const checkFormat = function(payload) {
    //console.log(moment(payload.chargeDate, "YYYY-MM-DD"))
    let format = {
        //issuer_rut: payload.rut, //'issuer_rut' => '18956344-2', // Sin puntos con guión
        //issuer_name: payload.name, //'issuer_name' => 'Waldo Rojas',
        pos_payment_check_type_id: payload.checkTypeId, //'pos_payment_check_type_id' => 1, // 1: Cheque a Fecha, 2: Cheque al Día
        charge_date: payload.chargeDate, //'charge_date' => '2019-02-24', // <-- Solo va si es cheque a fecha, sino null
        serial_number: payload.serialNumber, //'serial_number' => 'ABC-DEF-GHI' // <-- Opcional (Por ahora)
        g_bank_id: payload.bankId,
        account_number: parseInt(payload.accountNumber), // N° de cuenta
        plaza: parseInt(payload.plaza), // N° de plaza o sucursal
    }

    console.log('FORMAT', format)
    return format
}

const dtFetchData = getFetchDataFunction(
    process.env.VUE_APP_API_ROUTE + '/pos_sale?filter[g_state_id]=19',
    [
        'sl_sale_ticket',
        'sl_sale_invoice',
        'pos_detail_sales.wh_product',
        'sl_customer',
        'g_seller_user.hr_employee',
        'g_supervisor_user.hr_employee',
        'g_cashier_user.hr_employee',
    ],
    ['payments'],
    null
)

const dtFecthDataReprint = getFetchDataFunction(
    process.env.VUE_APP_API_ROUTE + '/pos_sale?filter[g_state_id]=19',
    [
        'sl_sale_ticket',
        'sl_sale_invoice',
        'sl_customer',
        'g_seller_user.hr_employee',
        'g_cashier_user.hr_employee',
    ],
    null
)

console.log(dtFetchData)

export default {
    fetch,
    fetchSale,
    fetchBanks,
    sendSale,
    annulSale,
    fetchSaleEmployee,
    dtFetchData,
    fetchSaleWithPayment,
    dtFecthDataReprint,
}
